<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <h2 class="flex-grow-1">Mail Templates</h2>
            <div>
                <el-button type="primary" size="small" @click="onShowAdd">Add template</el-button>
            </div>
        </div>
        <div class="page-section">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="id" width="80" label="ID"/>
                <el-table-column prop="name" :label="$t('common.name')"/>
                <el-table-column prop="created_at" :label="$t('common.created_at')" width="170"/>
                <el-table-column width="80" :label="$t('common.option')" align="right">
                    <template slot-scope="scope">
                        <a @click="onShowEdit(scope.row)">{{ $t('common.edit') }}</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tablenav-bottom">
                <div class="table-actions">
                    <el-button size="small" type="primary" :disabled="selectionIds.length===0" @click="onDelete">
                        {{ $t('common.batch_delete') }}
                    </el-button>
                </div>
                <el-pagination
                        background
                        layout="prev, pager, next, total"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="page"
                        @current-change="onPageChange"
                />
            </div>
        </div>

        <el-dialog title="Edit Template" closeable :visible.sync="showDialog" :close-on-click-modal="false"
                   :close-on-press-escape="false" width="60%">
            <el-form label-width="60px">
                <el-form-item :label="$t('common.name')">
                    <el-input size="medium" v-model="template.name"/>
                </el-form-item>
                <el-form-item :label="$t('common.content')">
                    <wang-editor height="300" v-model="template.content"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" class="w100" @click="onSubmit">{{ $t('common.submit') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </main-layout>
</template>

<script>
import ApiService from "../utils/ApiService";
import Pagination from "../mixins/Pagination";

export default {
    name: "MailTemplateList",
    mixins: [Pagination],
    data() {
        return {
            template: {},
            showDialog: false
        }
    },
    methods: {
        listApi() {
            return '/buildium/mail-templates';
        },
        resetData() {
            this.template = {
                id: null,
                name: '',
                content: ''
            };
        },
        onDelete() {
            let ids = this.selectionIds.map((d) => d.id);
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                ApiService.delete('/buildium/mail-templates/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                    this.$message.success(this.$t('Delete success'));
                }).catch((reason) => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.selectionIds = [];
                });
            });
        },
        onSubmit() {
            let {template} = this;
            if (!template.name) {
                this.$message.error('name required');
                return false;
            }

            if (template.id) {
                ApiService.put('/buildium/mail-templates/' + template.id, template).then(() => {
                    this.showDialog = false;
                    this.resetData();
                    this.fetchList();
                });
            } else {
                ApiService.post('/buildium/mail-templates', template).then(() => {
                    this.showDialog = false;
                    this.resetData();
                    this.fetchList();
                });
            }
        },
        onShowAdd() {
            this.resetData();
            this.showDialog = true;
        },
        onShowEdit(d) {
            this.template = d;
            this.showDialog = true;
        },
        onSelectionChange(val) {
            this.selectionIds = val;
        }
    },
    mounted() {
        this.fetchList();
    },
}
</script>

<style scoped>

</style>
